import Immutable from 'immutable';

/**
 * Parse a preload query (eg from WordPress) with full identifiers into a nested object ready for
 * merging with form state.
 * @todo this function needs a better name
 * @param {Object} query - The query with full identifiers - eg {'data.whatToCompare': 'E'}
 * @returns {Object} - A nested Immutable map of the query - eg Map({'data': {'whatToCompare': 'E'}})
 */
export const nestFlatQuery = (query) => {
    let values = Immutable.Map();
    for (const fullKey of Object.keys(query)) {
        const parts = fullKey.split('.');
        // disable the rule here till I figure out how to make this work without multiple declarations.
        // eslint-disable-next-line one-var-declaration-per-line, one-var
        let obj, o = obj = {};
        parts.forEach(
            (key, index) => {
                if (index === parts.length - 1) {
                    o = o[key] = query[fullKey];
                } else {
                    o = o[key] = {};
                }
            });
        values = values.mergeDeep(Immutable.fromJS(obj));
    }
    return values;
};

/**
 * Take a nested object and flatten it to a single dimensional object, with '.'s separating each part of the path
 * eg: {a: {b: {c: {d: null}}}} => {a.b.c.d: null}
 * @param {Object} object - The object to flatten
 * @param {String} baseKey - A base key to add to the start of each flattened path
 * @param {*} leafValue - A value to place at the leaf nodes. If this isn't given then the value at each leaf node is used.
 * @returns {Object} - The flattened object
 */
export const flattenNestedObject = (object, baseKey, leafValue) => {
    return Object.assign({}, ...(function _flatten(child, path = (baseKey && baseKey.split('.')) || []) {
        return [].concat(...Object.keys(child).map((key) => {
            if (typeof child[key] === 'object' && !Array.isArray(child[key]) && child[key] !== null) {
                return _flatten(child[key], path.concat([key]));
            }
            const value = leafValue === undefined ? child[key] : leafValue;
            return ({ [path.concat([key]).join('.')]: value });
        }));
    }(object)));
};
